import React from 'react'
import type { Role, SuperAdminRole, RoleSwitchProps } from '../../types/roles'

const rolesByLeastPermissive: Role[] = ['VIEW', 'EDIT', 'RULES_ADMIN', 'ADMIN']
const superAdminRolesByLeastPermissive: SuperAdminRole[] = [
  'OBSERVER',
  'SYSTEM_ADMIN',
  'SERVER_ADMIN',
  'SUPERADMIN'
]

export function getLeastPermissiveRole(roles: Role[]) {
  return rolesByLeastPermissive[
    Math.min(...roles.map((role) => rolesByLeastPermissive.indexOf(role)))
  ]
}

export function getMostPermissiveRole(roles: Role[]) {
  return rolesByLeastPermissive[
    Math.max(...roles.map((role) => rolesByLeastPermissive.indexOf(role)))
  ]
}

export function hasRole(role: Role, requiredRole: Role) {
  return rolesByLeastPermissive.indexOf(role) >= rolesByLeastPermissive.indexOf(requiredRole)
}

const renderNothing = () => false

function getRoleSwitch<TRole extends string>(rolesByLeastPermissive: TRole[]) {
  return function RoleSwitch({
    role,
    requiredRole,
    renderAllowed,
    renderDenied = renderNothing
  }: RoleSwitchProps<TRole>) {
    return (
      <>
        {rolesByLeastPermissive.indexOf(role) >= rolesByLeastPermissive.indexOf(requiredRole)
          ? renderAllowed()
          : renderDenied()}
      </>
    )
  }
}

export const RoleSwitch = getRoleSwitch(rolesByLeastPermissive)
export const SuperAdminRoleSwitch = getRoleSwitch(superAdminRolesByLeastPermissive)
